import { IState } from "../interfaces/config/state.model.interface";
import { StatusType } from "../../enums/StatusType";

export class State implements IState {
    public statusType: StatusType;
    public name: string;

    constructor(statusType: StatusType = StatusType.Live, name: string = "Live") {
        this.name = name;
        this.statusType = statusType;
    }
}
